<template>
	<!-- R: Vyhodil som tu uplne skelet kedze cakame na farbu aj tak nech to neblika -->
	<div v-if="currentHint" class="mdx-hint" :style="{ backgroundColor: currentHint.color ? currentHint.color : 'var(--ion-color-success)' }">
		<!-- R: Nemozes prekladat texty z BE, tie sa prekladaju na BE. Takze By si skoncil v "dvojitom preklade" -->
		<p class="title" v-if="currentHint.title">{{ currentHint.title }}</p>
		<p v-html="dompurify(currentHint.content)"></p>

		<div class="mdx-hint__progress" :style="`width: ${hintProgress}%`"></div>
	</div>
</template>

<script setup>
import { useGetHintGroup, useGetAllHintGroup } from '@/plugins/app/api'
import { computed, ref } from 'vue'
import { onUnmounted } from 'vue'
import { dompurify } from '@/plugins/app/_config/modules/global-properties'

const props = defineProps({
	slug: {
		type: String,
		required: true
	}
})
const currentIndex = ref(0)
const hintProgress = ref(0)

const { data: hintGroupAll } = useGetAllHintGroup()

const hintGroup = computed(() => {
	if (!hintGroupAll.value) return null
	return hintGroupAll.value.find(hint => hint?.slug === props.slug)
})

const currentHint = computed(() => {
	if (!hintGroup.value?.hints?.[currentIndex.value]) return null
	return {
		content: hintGroup.value?.hints?.[currentIndex.value]?.content,
		title: hintGroup.value?.hints?.[currentIndex.value]?.title,
		color: hintGroup.value?.color
	}
})

const progressInterval = setInterval(() => {
	if (hintProgress.value == 100) {
		hintProgress.value = 0
		currentIndex.value = currentIndex.value + 1 >= hintGroup.value?.hints?.length ? 0 : currentIndex.value + 1
	}

	hintProgress.value += 0.5
}, 30)

onUnmounted(() => clearInterval(progressInterval))
</script>

<style lang="sass" scoped>
.mdx-hint
	@apply h-auto px-[15px] pt-[10px] pb-[15px] relative

	p
		@apply text-[#fff] leading-[20px] font-bold

		&.title
			@apply mb-[10px]

		:deep(p)
			@apply text-[#fff]

	&__progress
		@apply absolute bottom-0 left-0 h-[5px] mt-[10px] bg-[#fff]
		background: linear-gradient(90deg, rgba(var(--ion-color-primary-contrast-rgb), 0.8) 0%, rgba(var(--ion-color-primary-contrast-rgb), 0.7) 80%, rgba(var(--ion-color-primary-contrast-rgb), 0) 100%)
</style>
